export const LitreVolumeState = (validations = [], props) => ({
  value: "",
  name: "literVolume",
  placeholder: "0.000 L",
  validations: [...validations],
  ...props,
});
